// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '@/style/reset.css'
import '@/common/elementui.js'
import './library/flexible'
import promise from 'es6-promise'
import './style/public.scss'
import $ from 'jquery'
import 'font-awesome/css/font-awesome.min.css';
import store from './store';
import VueDragResize from 'vue-drag-resize';
import globalApi from './common/globalApi'

Vue.config.productionTip = false

Vue.component('vue-drag-resize', VueDragResize);
router.beforeEach((to, from, next) => {
   let loginType = localStorage.getItem('loginType')
// console.log(loginType)
  if(to.name != 'stuLogin' && !loginType){

    alert('请先登陆')

    router.push({
      path: '/stuLogin'
    })
    return
  }

  next()
})

// 设置浏览器标题
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})
Vue.use(globalApi, store);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js